import { Controller, useFormContext } from 'react-hook-form';
import { useEffectOnce } from 'react-use';
import { ParseKeys } from 'i18next';
import { useTranslation } from 'next-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@zep/ui/experimental';
import { priceConcernAnswerMap, priceConcernTranslationMap } from './schema';
export const PriceConcernContent = ({
  isKRW
}: {
  isKRW: boolean;
}) => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    control,
    resetField
  } = useFormContext();
  const currency = isKRW ? 'KRW' : 'USD';
  useEffectOnce(() => {
    return () => {
      resetField('cancelReason.priceConcernAnswer');
    };
  });
  return <>
      <p className="text-body-2-m text-gray-600">
        {t('subscription:unsubscribe.79fa5660', '사용 가능한 예산이 얼마이신가요?')}
      </p>
      <Controller control={control} name="cancelReason.priceConcernAnswer" render={({
      field: {
        onChange,
        value
      }
    }) => <Select onValueChange={onChange} value={value}>
            <SelectTrigger className="h-[40px] w-full data-[placeholder]:text-subtitle data-[placeholder]:font-[500] data-[placeholder]:text-gray-500">
              <SelectValue placeholder={t('subscription:unsubscribe.4c114ebd', '사용 가능 예산을 선택해 주세요')} />
            </SelectTrigger>
            <SelectContent className="max-h-[300px]">
              {priceConcernAnswerMap[currency].map(price => {
          const translationKey = priceConcernTranslationMap[currency][price as keyof (typeof priceConcernTranslationMap)[typeof currency]];
          return <SelectItem key={price} className="h-[36px]" value={price}>
                    {t(translationKey as ParseKeys<['subscription']>)}
                  </SelectItem>;
        })}
            </SelectContent>
          </Select>} data-sentry-element="Controller" data-sentry-source-file="PriceConcernContent.tsx" />
    </>;
};